export default {
    defaultErrorMsg: { code: 'Undefined slimpay error', label: 'Le paiement a été refusé.' },
    cardOperationResultMapping: {
        400: {
            code: 'Card Operator Refusal',
            label: 'Le paiement a été refusé par votre banque',
        },
        401: {
            code: 'Card bank refusal',
            label: 'Le paiement a été refusé par votre banque',
        },
        402: {
            code: 'Card access failure',
            label: 'Votre banque a rencontré une erreur technique qui a bloqué le paiement',
        },
        403: {
            code: 'Card number is invalid',
            label: 'Votre banque a refusé le paiement car le numéro de carte est incorrect',
        },
        404: {
            code: 'Card CVV is invalid',
            label: 'Votre banque a refusé le paiement car le code de vérification (CVV ou CVC) est incorrect',
        },
        405: {
            code: 'Card expiration date is invalid',
            label: 'Votre banque a refusé le paiement car la date d’expiration de la carte incorrecte',
        },
        406: {
            code: 'Card birth date is invalid',
            label: 'Votre banque a refusé le paiement suite à une erreur de saisie des informations de la carte',
        },
        407: {
            code: 'Card transaction reference is invalid',
            label: 'Le paiement a été refusé suite à une erreur de communication avec votre banque',
        },
        408: {
            code: 'Card is declared as lost',
            label: 'Votre banque a refusé le paiement car la carte a été déclarée comme perdue',
        },
        409: {
            code: 'Card is declared as stolen',
            label: 'Votre banque a refusé le paiement car la carte a été déclarée comme volée',
        },
    },
    transactionErrorCodeMapping: {
        100: { code: 'SlimPay internal error' },
        101: { code: 'Request data is missing' },
        102: { code: 'Request type is missing' },
        103: { code: 'Authentification data is missing' },
        104: { code: 'Site ID is not found' },
        105: { code: 'Incoherent is timestamp' },
        106: { code: 'Initialization code is missing' },
        107: { code: 'Initialization data is missing' },
        108: { code: 'Customer data is missing' },
        109: { code: 'Login failed' },
        111: { code: 'Payment type is invalid' },
        113: { code: 'Blob decoding failed' },
        118: { code: 'Payment type is missing' },
        119: { code: 'Transaction has been canceled by user', label: 'Vous avez annulé la transaction' },
        120: { code: 'Session timed out', label: 'Vous n’avez pas complété la transaction à temps' },
        121: { code: 'Entity type is invalid' },
        122: { code: 'Honorific prefix is invalid' },
        123: { code: 'First name is invalid' },
        124: { code: 'Last name is invalid' },
        125: { code: 'Email is invalid' },
        127: { code: 'Phone is invalid' },
        128: { code: 'Postal code is invalid' },
        129: { code: 'City is invalid' },
        133: { code: 'BIC is invalid', label: 'IBAN/BIC invalide' },
        134: { code: 'IBAN is invalid', label: 'IBAN/BIC invalide' },
        135: { code: 'Mandate reference is invalid' },
        136: { code: 'Debit amount is invalid' },
        137: { code: 'Debit execution date is invalid' },
        138: { code: 'Debit label is invalid' },
        139: { code: 'Card amount is invalid' },
        140: { code: 'Card operation type is invalid' },
        141: { code: 'Client reference is invalid' },
        142: { code: 'Company name is invalid' },
        143: { code: 'Organization id is invalid' },
        144: { code: 'Street1 is invalid' },
        145: { code: 'Street2 is invalid' },
        146: { code: 'Country is invalid' },
        147: { code: 'Transaction id is invalid' },
        148: { code: 'Not a SEPA account' },
        149: { code: 'Duplicate request' },
        150: { code: 'Receive payment amount is invalid' },
        151: { code: 'Receive payment deadline is invalid' },
        152: { code: 'Receive payment ID is invalid' },
        153: { code: 'Receive payment ID has already been used before' },
        154: { code: 'No mandate found with this reference' },
        156: { code: 'Invalid OTP key' },
        157: { code: 'Expired OTP key' },
        158: { code: 'Max OTP key tries' },
        159: { code: 'Incoherent mandate reference' },
        160: { code: 'Max OTP key sent' },
        161: { code: 'CSI is invalid' },
        162: { code: 'OTP channel type is invalid' },
        163: { code: 'Sequence type is invalid' },
        164: { code: 'DD ISTR type is invalid' },
        165: { code: 'Mandate transfer is invalid' },
        167: { code: 'Mandate sign date is invalid' },
        168: { code: 'Mandate source is invalid' },
        169: { code: 'Mandate file name is invalid' },
        170: { code: 'Mandate file content is invalid' },
        171: { code: 'Mandate sign status is invalid' },
        172: { code: 'Unauthorized operation', label: 'Opération refusée par votre banque' },
        173: { code: 'Mandate status is invalid' },
        174: { code: 'Address line 3 is invalid' },
        175: { code: 'Address line 4 is invalid' },
        176: { code: 'SEPA COM PACIFIC' },
        177: { code: 'Unreachable SEPA' },
        178: { code: 'Profile is invalid' },
        179: { code: 'Creditor is invalid' },
        180: { code: 'Mandate reference already exists' },
        181: { code: 'No documents to sign' },
        182: { code: 'Multiple entries found' },
        183: { code: 'Document already treated' },
        184: { code: 'Branch invalid' },
        185: { code: 'Frequency missing' },
        186: { code: 'Forbidden IBAN', label: 'IBAN interdit par la banque' },
        187: { code: 'Document template not found' },
        188: { code: 'Incorrect bank account owner', label: 'Propriétaire du compte invalide' },
    },
}



// WEBPACK FOOTER //
// ./src/states/paymentConfirmation/paymentConfirmation.constants.js